﻿// src/pages/cadastros/Empresa.jsx - VERSAO CORRIGIDA
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import {
  BuildingOfficeIcon,
  IdentificationIcon,
  PhoneIcon,
  EnvelopeIcon,
  MapPinIcon,
  CheckCircleIcon,
  ExclamationCircleIcon,
  PencilIcon,
  PlusIcon
} from '@heroicons/react/24/outline';

const Empresa = () => {
  const [empresa, setEmpresa] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [editando, setEditando] = useState(false);

  const { register, handleSubmit, reset, formState: { errors } } = useForm();

  useEffect(() => {
    carregarEmpresa();
  }, []);

  const carregarEmpresa = async () => {
    setCarregando(true);
    try {
      const response = await axios.get('/api/empresa');
      console.log('Dados da empresa recebidos:', response.data);
      
      if (response.data && Object.keys(response.data).length > 0) {
        setEmpresa(response.data);
        reset(response.data);
      } else {
        console.log('Nenhuma empresa cadastrada');
        setEmpresa(null);
      }
    } catch (error) {
      console.error('Erro ao carregar empresa:', error);
      if (error.response) {
        console.error('Status:', error.response.status);
        console.error('Data:', error.response.data);
      }
      toast.error('Erro ao carregar dados da empresa');
    } finally {
      setCarregando(false);
    }
  };

  const onSubmit = async (data) => {
  try {
    console.log('Enviando dados da empresa:', data);
    
    let response;
    if (empresa && empresa.id) {
      // Usar PUT para atualizar empresa existente
      response = await axios.put(`/api/empresa/${empresa.id}`, data);
      console.log('Resposta PUT do servidor:', response.data);
    } else {
      // Usar POST para criar nova empresa
      response = await axios.post('/api/empresa', data);
      console.log('Resposta POST do servidor:', response.data);
    }
    
    // Atualizar estado com os dados retornados
    setEmpresa(response.data.empresa || response.data);
    setEditando(false);
    
    toast.success(empresa ? 'Empresa atualizada com sucesso!' : 'Empresa cadastrada com sucesso!');
    
  } catch (error) {
    console.error('Erro ao salvar empresa:', error);
    if (error.response) {
      console.error('Status:', error.response.status);
      console.error('Data:', error.response.data);
      
      // Tratar erros especificos
      if (error.response.status === 400 && error.response.data.error === 'CNPJ já cadastrado') {
        toast.error('Este CNPJ já está cadastrado para outra empresa.');
      } else if (error.response.status === 404) {
        toast.error('Empresa não encontrada no sistema.');
      } else {
        toast.error(error.response.data.message || 'Erro ao salvar empresa');
      }
    } else {
      toast.error('Erro de conexão com o servidor');
    }
  }
};

  if (carregando) {
    return (
      <div className="flex flex-col items-center justify-center h-64">
        <div className="loader h-8 w-8"></div>
        <span className="ml-3 text-gray-600">Carregando dados da empresa...</span>
      </div>
    );
  }

  return (
    <div className="animate-fade-in">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Cadastro da Empresa</h1>
          <p className="text-gray-600">Informações gerais da sua empresa</p>
        </div>
        {empresa && !editando && (
          <button
            onClick={() => setEditando(true)}
            className="btn-primary"
          >
            <PencilIcon className="h-5 w-5 mr-2" />
            Editar Empresa
          </button>
        )}
      </div>

      {empresa ? (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Coluna 1 */}
            <div className="space-y-6">
              <div className="card">
                <div className="card-header">
                  <div className="flex items-center">
                    <BuildingOfficeIcon className="h-5 w-5 text-primary-600 mr-2" />
                    <h3 className="text-lg font-semibold">Informações Básicas</h3>
                  </div>
                </div>
                <div className="card-body space-y-4">
                  <div className="form-group">
                    <label className="form-label">Nome da Empresa *</label>
                    <input
                      type="text"
                      {...register('nome', { 
                        required: 'Nome é obrigatório',
                        minLength: {
                          value: 3,
                          message: 'Mínimo 3 caracteres'
                        }
                      })}
                      className="form-input"
                      disabled={!editando}
                      defaultValue={empresa.nome}
                    />
                    {errors.nome && (
                      <p className="form-error">{errors.nome.message}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="form-label">CNPJ *</label>
                    <input
                      type="text"
                      {...register('cnpj', { 
                        required: 'CNPJ é obrigatório',
                        pattern: {
                          value: /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/,
                          message: 'Formato: 00.000.000/0000-00'
                        }
                      })}
                      className="form-input"
                      disabled={!editando}
                      placeholder="00.000.000/0000-00"
                      defaultValue={empresa.cnpj}
                    />
                    {errors.cnpj && (
                      <p className="form-error">{errors.cnpj.message}</p>
                    )}
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-header">
                  <div className="flex items-center">
                    <PhoneIcon className="h-5 w-5 text-primary-600 mr-2" />
                    <h3 className="text-lg font-semibold">Contato</h3>
                  </div>
                </div>
                <div className="card-body space-y-4">
                  <div className="form-group">
                    <label className="form-label">Telefone</label>
                    <input
                      type="text"
                      {...register('telefone')}
                      className="form-input"
                      disabled={!editando}
                      placeholder="(00) 00000-0000"
                      defaultValue={empresa.telefone}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      {...register('email', {
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                          message: 'Email inválido'
                        }
                      })}
                      className="form-input"
                      disabled={!editando}
                      placeholder="empresa@exemplo.com"
                      defaultValue={empresa.email}
                    />
                    {errors.email && (
                      <p className="form-error">{errors.email.message}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Coluna 2 */}
            <div className="space-y-6">
              <div className="card">
                <div className="card-header">
                  <div className="flex items-center">
                    <MapPinIcon className="h-5 w-5 text-primary-600 mr-2" />
                    <h3 className="text-lg font-semibold">Endereço</h3>
                  </div>
                </div>
                <div className="card-body">
                  <div className="form-group">
                    <label className="form-label">Endereço Completo</label>
                    <textarea
                      {...register('endereco')}
                      className="form-textarea"
                      rows="4"
                      disabled={!editando}
                      placeholder="Rua, Número, Bairro, Cidade - Estado"
                      defaultValue={empresa.endereco}
                    />
                  </div>
                </div>
              </div>

              {/* Informações do Sistema */}
              <div className="card bg-gray-50 border-gray-200">
                <div className="card-header">
                  <div className="flex items-center">
                    <IdentificationIcon className="h-5 w-5 text-gray-600 mr-2" />
                    <h3 className="text-lg font-semibold">Informações do Sistema</h3>
                  </div>
                </div>
                <div className="card-body space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">Data de Cadastro:</span>
                    <span className="font-medium">
                      {empresa.created_at 
                        ? new Date(empresa.created_at).toLocaleDateString('pt-BR')
                        : 'Não informada'}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">Status:</span>
                    <span className="badge-success">Ativa</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">ID no Sistema:</span>
                    <span className="font-mono text-sm">{empresa.id || '1'}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Botoes de Acao */}
          {editando && (
            <div className="mt-8 pt-6 border-t border-gray-200">
              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={() => {
                    setEditando(false);
                    reset(empresa);
                  }}
                  className="btn-secondary"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="btn-success"
                >
                  <CheckCircleIcon className="h-5 w-5 mr-2" />
                  Salvar Alterações
                </button>
              </div>
            </div>
          )}
        </form>
      ) : (
        <div className="card">
          <div className="card-body text-center py-12">
            <BuildingOfficeIcon className="h-16 w-16 mx-auto text-gray-300 mb-4" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Nenhuma empresa cadastrada</h3>
            <p className="text-gray-600 mb-6">
              Cadastre os dados da sua empresa para começar a usar o sistema.
            </p>
            <button
              onClick={() => {
                // Inicializar dados vazios para novo cadastro
                reset({
                  nome: '',
                  cnpj: '',
                  telefone: '',
                  email: '',
                  endereco: ''
                });
                setEditando(true);
              }}
              className="btn-primary"
            >
              <PlusIcon className="h-5 w-5 mr-2" />
              Cadastrar Empresa
            </button>
          </div>
        </div>
      )}

      {/* Dicas */}
      {!editando && empresa && (
        <div className="mt-8 card bg-blue-50 border-blue-200">
          <div className="card-body">
            <div className="flex items-start">
              <ExclamationCircleIcon className="h-5 w-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" />
              <div>
                <h4 className="font-semibold text-blue-800 mb-2">Informações importantes</h4>
                <ul className="space-y-1 text-blue-700">
                  <li>- Mantenha os dados da empresa sempre atualizados</li>
                  <li>- O CNPJ é utilizado para emissão de relatórios</li>
                  <li>- O email é utilizado para notificações do sistema</li>
                  <li>- Atualize o cadastro em caso de mudança de endereço</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Empresa;


